import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class FsWhoosterHistoryModel extends SnModel {
  @Expose()
  public uuid: string;

  @Expose()
  public user: string;

  @Expose()
  public searchParameter: string;

  @Expose()
  public searchType: string;

  constructor(data: any) {
    super();
    this.fromJSON(data);
    this.uuid = data?.id;
    this.user = `${data?.user?.firstName} ${data?.user?.lastName}`;
    this.searchParameter = data?.searchParams?.address
      ? this.formatAddress(data?.searchParams)
      : this.formatPhone(data?.searchParams?.phoneNumber);
  }

  public formatAddress(items: any): any {
    this.searchType = 'address';
    return `${items?.address}, ${items?.city}, ${items?.state}, ${items?.zip}`;
  }

  public formatPhone(item: any): any {
    this.searchType = 'phone';
    return item;
  }
}
